import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';
import {ConfigManager, Dispatcher} from '@yosmanyga/base';
import {FeedbackApi} from '../data';

class AppUnreadFeedbackController {
    loaded: boolean;
    unread: number;

    constructor(
        private dispatcher: Dispatcher,
        private feedbackApi: FeedbackApi,
        private configManager: ConfigManager
    ) {
        this.loaded = false;
        this.unread = 0;

        this.dispatcher.register('config_set', this.listenToConfigSet);

        makeObservable(this, {
            loaded: observable,
            unread: observable,
            load: action,
        });
    }

    load = async () => {
        const from = (await this.configManager.get('feedback_read')) as number;

        const unread = await this.feedbackApi.countUnreadSysMessageIndexes(
            from || 0
        );

        runInAction(() => {
            this.unread = unread;
            this.loaded = true;
        });
    };

    listenToConfigSet = (key: string) => {
        if (key !== 'feedback_read') {
            return;
        }

        runInAction(() => {
            this.unread = 0;
        });
    };
}

decorate(injectable(), AppUnreadFeedbackController);
decorate(inject(Dispatcher), AppUnreadFeedbackController, 0);
decorate(inject(FeedbackApi), AppUnreadFeedbackController, 1);
decorate(inject(ConfigManager), AppUnreadFeedbackController, 2);

export {AppUnreadFeedbackController};
